export const convertTo12Hour = (time24) => {
    if(time24){
      // Split the time into hours, minutes, and seconds
    let [hours, minutes, seconds] = time24?.split(":")?.map(Number);
    // Determine AM or PM
    let period =  parseInt(hours) > 11 ? "PM" : "AM";
    // Convert to 12-hour format
    hours = hours % 12 || 12; // Convert '0' or '12' to '12' for 12-hour format
    // Return the formatted time in 12-hour format
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")} ${period}`;
    }
  }